import { z } from "zod";
import { FavoriteRefSchema, type FavoriteRef } from "@/shared/lib/db-schema";

const KEY = "eurostyle_favorites_v1";
const FavoriteRefListSchema = z.array(FavoriteRefSchema);

function lsGet(): unknown {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
function lsSet(value: ReadonlyArray<FavoriteRef>): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* quota or disabled */
  }
}

function cloudGet(): Promise<string | null> {
  return new Promise((resolve) => {
    const cs = window.Telegram?.WebApp?.CloudStorage;
    if (!cs) return resolve(null);
    cs.getItem(KEY, (err, value) => resolve(err ? null : value ?? null));
  });
}
function cloudSet(value: string): Promise<boolean> {
  return new Promise((resolve) => {
    const cs = window.Telegram?.WebApp?.CloudStorage;
    if (!cs) return resolve(false);
    cs.setItem(KEY, value, (err) => resolve(!err));
  });
}

function parseList(raw: unknown): FavoriteRef[] {
  if (!Array.isArray(raw)) return [];
  const r = FavoriteRefListSchema.safeParse(raw);
  return r.success ? r.data : [];
}

export async function loadFavorites(): Promise<FavoriteRef[]> {
  const fromCloud = await cloudGet();
  if (fromCloud) {
    try {
      return parseList(JSON.parse(fromCloud));
    } catch {
      return [];
    }
  }
  return parseList(lsGet());
}

export async function saveFavorites(items: ReadonlyArray<FavoriteRef>): Promise<void> {
  lsSet(items);
  await cloudSet(JSON.stringify(items));
}
